
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';
import {getStorage} from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyB2slASa5jJ3Q6OCV83ZmP9TRi2SAexhAQ",
  authDomain: "luismart-60238.firebaseapp.com",
  projectId: "luismart-60238",
  storageBucket: "luismart-60238.appspot.com",
  messagingSenderId: "55096958399",
  appId: "1:55096958399:web:25edd85e6ea62134de550a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;